// Dependencies
require("webstrap/type");

// Styles
require("./information.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/information/index.js
 ** module id = 149
 ** module chunks = 0 1
 **/